import React from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  ADDRESS_FIELD_LABELS,
  COUNTRIES,
  PRIORITY_COUNTRY_CODES,
} from "../../../utils/addressData";

export default function AddressDialog({
  open,
  isEditing,
  currentAddress,
  fieldErrors,
  onClose,
  onSave,
  onFieldChange,
  onToggleOutgoing,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle>
        {isEditing ? "Adresse bearbeiten" : "Adresse hinzufügen"}
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Bezeichnung (z. B. Geschäftssitz)"
            value={currentAddress.label}
            onChange={(e) => onFieldChange("label", e.target.value)}
            fullWidth
            required
            error={Boolean(fieldErrors.label)}
            helperText={fieldErrors.label || ""}
          />
          <TextField
            label="Name / Ansprechpartner"
            value={currentAddress.name}
            onChange={(e) => onFieldChange("name", e.target.value)}
            fullWidth
            error={Boolean(fieldErrors.name)}
            helperText={fieldErrors.name || ""}
          />
          <TextField
            label={ADDRESS_FIELD_LABELS.street}
            value={currentAddress.street}
            onChange={(e) => onFieldChange("street", e.target.value)}
            fullWidth
            required
            error={Boolean(fieldErrors.street)}
            helperText={fieldErrors.street || ""}
          />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 2fr" },
              gap: 2,
            }}
          >
            <TextField
              label={ADDRESS_FIELD_LABELS.zip}
              value={currentAddress.zip}
              onChange={(e) => onFieldChange("zip", e.target.value)}
              fullWidth
              required
              error={Boolean(fieldErrors.zip)}
              helperText={fieldErrors.zip || ""}
            />
            <TextField
              label={ADDRESS_FIELD_LABELS.city}
              value={currentAddress.city}
              onChange={(e) => onFieldChange("city", e.target.value)}
              fullWidth
              required
              error={Boolean(fieldErrors.city)}
              helperText={fieldErrors.city || ""}
            />
          </Box>

          <FormControl fullWidth required error={Boolean(fieldErrors.country)}>
            <InputLabel>{ADDRESS_FIELD_LABELS.country}</InputLabel>
            <Select
              label={ADDRESS_FIELD_LABELS.country}
              value={currentAddress.country || ""}
              onChange={(e) => onFieldChange("country", e.target.value || "")}
            >
              {PRIORITY_COUNTRY_CODES.map((code) => {
                const entry = COUNTRIES.find((country) => country.code === code);
                if (!entry) return null;
                return (
                  <MenuItem key={entry.code} value={entry.code}>
                    {entry.name}
                  </MenuItem>
                );
              })}
              <MenuItem disabled>──────────</MenuItem>
              {COUNTRIES.filter((c) => !PRIORITY_COUNTRY_CODES.includes(c.code)).map(
                (c) => (
                  <MenuItem key={c.code} value={c.code}>
                    {c.name}
                  </MenuItem>
                )
              )}
            </Select>
            {fieldErrors.country && (
              <FormHelperText>{fieldErrors.country}</FormHelperText>
            )}
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                checked={!!currentAddress.forOutgoingInvoice}
                onChange={(e) => onToggleOutgoing(e.target.checked)}
              />
            }
            label="Als Standard für Ausgangsrechnungen festlegen"
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          onClick={onSave}
          variant="contained"
          sx={{ bgcolor: "orange", "&:hover": { bgcolor: "#cc7a00" }, borderRadius: 2 }}
        >
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
}
